// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions-tos>ul>li{text-align:right}.actions-tos>ul>li>span{line-height:13px;font-size:12px;display:inline-block;width:200px;white-space:normal;text-align:left;vertical-align:middle;padding-left:5px}\n", ""]);
// Exports
module.exports = exports;
